/* esm.sh - date-fns@4.1.0/isDate */
function e(t){return t instanceof Date||typeof t=="object"&&Object.prototype.toString.call(t)==="[object Date]"}var o=e;export{o as default,e as isDate};
//# sourceMappingURL=isDate.mjs.map